var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ibi-investments-page"},[_c('dynamic-component-viewer',{attrs:{"component-name":_vm.componentName,"analytics-prefix":_vm.analyticsPrefix}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }